<template>
  <client-only>
    <div class="workers-saying-container">
      <v-row>
        <v-col class="say-hdr">מה אומרים עלינו?</v-col>
      </v-row>
      <v-carousel
        class="company-carousel"
        :hide-delimiters="Object.keys(companyTestimpnials).length < 2"
        :show-arrows="false"
        cycle
        hide-delimiter-background
        dark
        color="primary"
        height="auto"
      >
        <v-carousel-item v-for="(item , i) in companyTestimpnials" :key="i" color="primary">
          <v-sheet color="#3e4a54">
            <WorkerSay
              class="px-4"
              :by="item.By"
              :employeeImageLink="item.EmployeeImageLink"
              :testimonial="item.Testimonial"
              :testimonialId="item.TestimonialId"
            />
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
  </client-only>
</template>

<script>
import WorkerSay from '@/components/Company/WorkerSay'

export default {
  components: {
    WorkerSay
  },

  props: {
    companyTestimpnials: {
      type: Array
    }
  },

}
</script>

<style lang="scss" scoped>
.workers-saying-container {
  padding: 10px 15px 20px 0;
  background-color: rgb(62, 74, 84);
  .say-hdr {
    color: white;
    font-size: 36px;
    margin-right: 15px;
  }
}

@media only screen and (max-width: 600px) {
  .say-hdr {
    text-align: center;
  }
}
</style>


